/** funciones para el componente de asignaciones/reasignaciones */
import axiosMailUpdate from '../services/axiosApi'
var assigmentRequests = {
    async getAnalists() {
        const response = await axiosMailUpdate.get('api/v1/users?sort_by=name')
        //this.response = response.data.data.filter(el => el.idprofiles === 2 || el.idprofiles === 3 || el.idprofiles === 4)
        this.response = response.data.data
        return this.response
    },
    async toAssign(idRequest, dataToAssign) {
        const response = await axiosMailUpdate.put('api/v1/requests/'+idRequest+'/toassign',dataToAssign)
        this.response = response.data.data
        return this.response
    },
    async toReAssign(idRequest, dataToAssign, idUser) {
        const response = await axiosMailUpdate.put('api/v1/requests/'+idRequest+'/toassign/'+idUser,dataToAssign)
        this.response = response.data.data
        return this.response
    },
}
export default assigmentRequests